import {
  MESSAGETEMPLATESELECTDATA,
  TEMPLATESELECTDATA,
  SETTITLEDATA,
  SETPHONEMESSAGEDATA,
  SETSMSMESSAGEDATA,
  SETEMAILMESSAGEDATA,
  SETENGLISHPOSITIVERESPONSEDATA,
  SETENGLISHNEGATIVERESPONSEDATA,
  SETSPANISHPOSITIVERESPONSEDATA,
  SETSPANISHNEGATIVERESPONSEDATA,
  FETCH,
  SELECTIONDATA,
} from './actionType'
import axios from 'axios'
import tapConfig from '../../tapConfig'

export function messageTemplateSelectData(data) {
  return {
    type: MESSAGETEMPLATESELECTDATA,
    data: data,
  }
}
export function templateSelectData(data) {
  return {
    type: TEMPLATESELECTDATA,
    data: data,
  }
}
export function setTitleData(data) {
  return {
    type: SETTITLEDATA,
    data: data,
  }
}
export function setPhoneMessageData(data) {
  return {
    type: SETPHONEMESSAGEDATA,
    data: data,
  }
}
export function setSMSMessageData(data) {
  return {
    type: SETSMSMESSAGEDATA,
    data: data,
  }
}
export function setEmailMessageData(data) {
  return {
    type: SETEMAILMESSAGEDATA,
    data: data,
  }
}
export function setEnglishPositiveResponseData(data) {
  return {
    type: SETENGLISHPOSITIVERESPONSEDATA,
    data: data,
  }
}
export function setEnglishNegativeResponseData(data) {
  return {
    type: SETENGLISHNEGATIVERESPONSEDATA,
    data: data,
  }
}
export function setSpanishPositiveResponseData(data) {
  return {
    type: SETSPANISHPOSITIVERESPONSEDATA,
    data: data,
  }
}
export function setSpanishNegativeResponseData(data) {
  return {
    type: SETSPANISHNEGATIVERESPONSEDATA,
    data: data,
  }
}
export function setSelectionData(data) {
  return {
    type: SELECTIONDATA,
    data: data,
  }
}

export function listMessageTemplateData(blossomID) {
  return function (dispatch) {
    tapConfig()
      .then((config) => {
        const apiKey = config.target_outreach_manager.apiKey
        dispatch(apiFetching(true))
        axios
          .get(
            config.target_outreach_manager.url +
              'target_emergency_alerts/v1/message_templates?key=' +
              encodeURIComponent(apiKey) +
              '&group_id=' +
              encodeURIComponent(blossomID),
          )
          .then(function (response) {
            if (response.data === null) {
              response.data = ''
            }
            dispatch(messageTemplateSelectResponseData(response))
            dispatch(apiFetching(false))
          })
          .catch(function () {
            // removed error from function
            dispatch(apiFetching(false))
          })
      })
      .catch((error) => {
        console.error('Error fetching tapConfig:', error)
        dispatch(apiFetching(false))
      })
  }
}

function messageTemplateSelectResponseData(response) {
  return {
    type: MESSAGETEMPLATESELECTDATA,
    data: response.data,
  }
}

function apiFetching(status) {
  return {
    type: FETCH,
    fetching: status,
  }
}
